export enum Breakpoint {
    Mobile = 500,
    Tablet = 900,
    DesktopSmall = 1200,
    DesktopLarge = 1600,
}
